import { z } from 'zod';

import { auditSchema, positiveIntSchema } from './common';
import { boardIdSchema, matchIdSchema, tournamentIdSchema } from './ids';

export const boardStatusSchema = z.enum([
  'free', // frei
  'occupied', // belegt
  'disabled', // gesperrt, z. B. defektes Board
]);

export type BoardStatus = z.infer<typeof boardStatusSchema>;

/** A dart board at `tournaments/{tournamentId}/boards/{boardId}`. */
export const boardSchema = z.object({
  id: boardIdSchema,
  tournamentId: tournamentIdSchema,
  number: positiveIntSchema.max(999),
  /** Optional location hint for the announcer, e.g. "Bühne links". */
  label: z.string().trim().max(64).nullable(),
  status: boardStatusSchema,
  currentMatchId: matchIdSchema.nullable(),
  ...auditSchema.shape,
});

export type Board = z.infer<typeof boardSchema>;
